import type { FlatConfig } from './flatConfig';

// UI-only flags. Kept React-side; not part of the pure serializable domain (spec §7).
export interface ViewState {
  isNoReg: boolean;
  consultationMode: boolean;
  isPBUnit: boolean;
  cciEnabled: boolean;
  hybridEncodingSchemeUserSelected: boolean;
  afaEncodingSchemeUserSelected: boolean;
}

export function viewStateFromFlat(c: FlatConfig): ViewState {
  return {
    isNoReg: c.isNoReg,
    consultationMode: c.consultationMode,
    isPBUnit: c.isPBUnit,
    cciEnabled: c.cciEnabled,
    hybridEncodingSchemeUserSelected: c.hybridEncodingSchemeUserSelected,
    afaEncodingSchemeUserSelected: c.afaEncodingSchemeUserSelected,
  };
}

export function viewStateToFlat(v: ViewState): Pick<FlatConfig, keyof ViewState> {
  return { ...v };
}
